class BundleDiscountPricing {
  constructor() {
    this.discountTiers = {
      1: 10,
      2: 15,
      3: 20
    };

    this.priceBlock = document.querySelector(
      '[data-bundle-discount-eligible="true"]'
    );

    if (!this.priceBlock) return;

    this.price = this.priceBlock.querySelector('[data-product-price]');
    this.bundleComparePrice = this.priceBlock.querySelector(
      '[data-bundle-compare-price]'
    );
    this.bundleComparePriceWrap = this.priceBlock.querySelector(
      '[data-bundle-compare-price-wrap]'
    );

    this.bundleDiscountBadge = this.priceBlock.querySelector(
    '[data-bundle-discount-badge]'
    );

    this.cartState = document.querySelector('#bundle-discount-cart-state');

    this.init();
  }

  async init() {
    const hasBundleTrigger =
      this.cartState?.dataset.hasBundleTrigger === 'true';

    const accessoryCount = Number(
      this.cartState?.dataset.eligibleAccessoryCount || 0
    );

    const discount = this.getDiscountTier(
      accessoryCount,
      hasBundleTrigger
    );

    console.log('Bundle pricing state:', {
      accessoryCount,
      hasBundleTrigger,
      discount
    });

    this.updatePrice(discount);
    this.setupCartListener()
  }

  getDiscountTier(accessoryCount, hasBundleTrigger) {
    if (!hasBundleTrigger) {
      return 0;
    }

    if (accessoryCount >= 2) {
      return this.discountTiers[3];
    }

    if (accessoryCount === 1) {
      return this.discountTiers[2];
    }

    return this.discountTiers[1];
  }

  getDiscountedPrice(price, discount) {
    return price - (price * discount / 100);
  }

  formatMoney(cents) {
    return `${new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100)}`;
  }

  updatePrice(discount) {
    if (!this.price) return;

    const originalPrice = Number(
      this.price.dataset.productPriceValue
    );

    if (!discount) {
      this.bundleDiscountBadge?.classList.add('hide')
      this.price.textContent = this.formatMoney(originalPrice);

      if (this.bundleComparePriceWrap) {
        this.bundleComparePriceWrap.classList.add('hide');
      }

      return;
    }

    const discountedPrice = this.getDiscountedPrice(originalPrice, discount);

    this.bundleComparePrice.textContent =this.formatMoney(originalPrice);
    this.bundleComparePriceWrap.classList.remove('hide');

    this.price.textContent = this.formatMoney(discountedPrice);
    this.price.classList.toggle('on-bundle-discount',discount > 0);
    this.bundleDiscountBadge.textContent = `${discount}% OFF`;
    this.bundleDiscountBadge.classList.remove('hide');
  }

  async refreshBundleState() {
    const response = await fetch(window.location.href);

    if (!response.ok) {
        throw new Error('Failed to refresh bundle discount state.');
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const cartState = doc.querySelector('#bundle-discount-cart-state');

    if (!cartState) return;

    const hasBundleTrigger =
        cartState.dataset.hasBundleTrigger === 'true';

    const accessoryCount = Number(
        cartState.dataset.eligibleAccessoryCount || 0
    );

    const discount = this.getDiscountTier(
        accessoryCount,
        hasBundleTrigger
    );

    this.updatePrice(discount);

    console.log('Updated bundle pricing:', {
        accessoryCount,
        hasBundleTrigger,
        discount
    });
    }
    setupCartListener() {
        document.addEventListener('rebuy:cart.change', () => {
            this.refreshBundleState();
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
  new BundleDiscountPricing();
});